/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * last_week object
 * @export
 * @interface GetFwLeaderboardsCorporationsLastWeekLastWeek1
 */
export interface GetFwLeaderboardsCorporationsLastWeekLastWeek1 {
    /**
     * Amount of victory points
     * @type {number}
     * @memberof GetFwLeaderboardsCorporationsLastWeekLastWeek1
     */
    amount?: number;
    /**
     * corporation_id integer
     * @type {number}
     * @memberof GetFwLeaderboardsCorporationsLastWeekLastWeek1
     */
    corporationId?: number;
}

/**
 * Check if a given object implements the GetFwLeaderboardsCorporationsLastWeekLastWeek1 interface.
 */
export function instanceOfGetFwLeaderboardsCorporationsLastWeekLastWeek1(value: object): value is GetFwLeaderboardsCorporationsLastWeekLastWeek1 {
    return true;
}

export function GetFwLeaderboardsCorporationsLastWeekLastWeek1FromJSON(json: any): GetFwLeaderboardsCorporationsLastWeekLastWeek1 {
    return GetFwLeaderboardsCorporationsLastWeekLastWeek1FromJSONTyped(json, false);
}

export function GetFwLeaderboardsCorporationsLastWeekLastWeek1FromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFwLeaderboardsCorporationsLastWeekLastWeek1 {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'corporationId': json['corporation_id'] == null ? undefined : json['corporation_id'],
    };
}

export function GetFwLeaderboardsCorporationsLastWeekLastWeek1ToJSON(json: any): GetFwLeaderboardsCorporationsLastWeekLastWeek1 {
    return GetFwLeaderboardsCorporationsLastWeekLastWeek1ToJSONTyped(json, false);
}

export function GetFwLeaderboardsCorporationsLastWeekLastWeek1ToJSONTyped(value?: GetFwLeaderboardsCorporationsLastWeekLastWeek1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'corporation_id': value['corporationId'],
    };
}

